

/**
* Helper functions related to URLs.
*/
const urlHelpers = {
  /**
  * Adds a `ref` querystring param to the give url. Assumes the url is a valid url.
  * `ref` is not added to urls that are to an external site.
  *
  * @param href {string} a valid url string.
  * @param ref {string} the ref value.
  */
  addRef(href, ref) {
    const pageUrl = new Url()
    const url = new Url(href)
    const isHttp = url.protocol.indexOf('http') > -1
    const sameHost = pageUrl.host === url.host

    return isHttp && sameHost ? this.addParam(href, 'ref', ref) : href
  },

  /**
  * Adds a querystring param to the give url. Assumes the url is a valid url.
  *
  * @param url {string} a valid url string.
  * @param param {string} the parameter name.
  * @param value {string} the parameter value.
  */
  addParam(url, param, value, shouldEncode) {
    if (!url || !param || !value) {
      return url || ''
    }

    if (shouldEncode || (shouldEncode === undefined || shouldEncode == null)) {
      param = encodeURIComponent(param)
      value = encodeURIComponent(value)
    }

    if (Array.isArray(value)) {
      value.map((val) => {
        url = urlHelpers.addParam(url, param, val, shouldEncode)
      })

      return url
    } else if (url.indexOf('?') > -1) {
      return `${url}&${param}=${value}`
    }

    return `${url}?${param}=${value}`
  },

  /**
  * Adds given params to the given url. Assumes the url is a valid url.
  *
  * @param url {string} a valid url.
  * @param params {object} key values of params to be added.
  */
  addParams(url, params, shouldEncode) {
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        url = this.addParam(url, key, params[key], shouldEncode)
      }
    }

    return url
  },

  /**
  * Returns the value of the parameter in the url. If the parameter is nothing
  * present then null is returned.
  * Taken from: https://stackoverflow.com/a/901144
  *
  * @param name {string} query parameter
  * @param url {string} url
  */
  getParam(name, url) {
    if (!url) {
      url = window.location.href
    }
    name = name.replace(/[\[\]]/g, '\\$&')
    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`)


    const results = regex.exec(url)

    if (!results) {
      return null
    }

    if (!results[2]) {
      return ''
    }

    return decodeURIComponent(results[2].replace(/\+/g, ' '))
  },

  /**
  * Builds a link with the given url allowing access to built in link methods
  * to get values such as `protocol`, `hostname`, `pathname`, `port`, and `hash`.
  *
  * @param url {string}
  */
  parseUrl(url) {
    if (!url) return {}
    const a = document.createElement('a')

    a.href = url

    return a
  },
}

export default urlHelpers
